import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <title id="Plug">{props.title || 'Plug'}</title>
      <g>
        <path d="M22.69 5.86c.32.32.48.7.48 1.16 0 .46-.16.85-.48 1.18l-5.18 5.17 1.94 1.94-2.07 2.07c-1.41 1.4-3.09 2.21-5.04 2.41-1.95.2-3.72-.23-5.32-1.3l-4.68 4.68h-2.34v-2.34l4.68-4.68c-1.07-1.6-1.5-3.37-1.3-5.32.2-1.95 1.01-3.63 2.41-5.04l2.07-2.07 1.94 1.94 5.17-5.18c.33-.32.72-.48 1.18-.48.46 0 .84.16 1.16.48.32.32.48.71.48 1.17 0 .46-.16.85-.48 1.17l-5.17 5.18 3.03 3.03 5.18-5.17c.33-.32.72-.48 1.18-.48.46 0 .84.16 1.16.48z" />
      </g>
    </Icon>
  )
}



// WEBPACK FOOTER //
// ./client/components/icons/plug.js